import React from 'react';

import MaxWidth from '@marvelapp/marvel-ui/max-width';
import Spacing from '@marvelapp/marvel-ui/spacing';
import Heading from '@marvelapp/marvel-ui/heading';
import Paragraph from '@marvelapp/marvel-ui/paragraph';
import Align from '@marvelapp/marvel-ui/align';
import Grid, { GridItem } from '@marvelapp/marvel-ui/grid';

import Image from 'marketing-website/components/modules/Image';

import assets from 'marketing-website/configs/pages/apple-watch-prototyping/assets';

export default function Ideas() {
  return (
    <Spacing size="l" sizeM="xl" type="padding" position="topBottom">
      <MaxWidth value={720}>
        <Grid columns={2} size="l" alignItems="center" justifyContent="center">
          <GridItem>
            <Image {...assets.apps} />
          </GridItem>
          <GridItem columnSpan={2} columnSpanM={1}>
            <Align type="center" typeM="left">
              <Spacing size="s" type="padding" position="topBottom">
                <Heading tag="h2" weight="semibold" size="xl">
                  Bring your app ideas to life
                </Heading>
              </Spacing>
              <Paragraph size="l" color="slate">
                Build your app prototypes on the web or directly on your iPhone
                or iPad. Once you’re ready you can beam them directly to the
                Apple Watch and preview.
              </Paragraph>
            </Align>
          </GridItem>
        </Grid>
      </MaxWidth>
    </Spacing>
  );
}



// WEBPACK FOOTER //
// ./src/pages/apple-watch-prototyping/ideas.js